// @ts-strict-ignore
import apisauce from 'apisauce'
import url from 'url'

import { select, call } from 'typed-redux-saga'

import { RootState } from 'APP/Store/CreateStore'

import { ResultsResponse } from '@dialogue/smartsearch'

export const selectAccessToken = (state: RootState) => state.login.accessToken

export function* getSearchResults(
  source: string,
  query: string
): Generator<any, ResultsResponse, any> {
  if (!source) {
    throw new Error('Smart search source is not set')
  }

  const accessToken = yield* select(selectAccessToken)

  if (!accessToken) {
    throw new Error('Missing access token')
  }

  const sourceURLObj = url.parse(source, true)
  const baseURL = url.format({
    ...sourceURLObj,
    search: undefined,
    pathname: undefined,
    query: undefined,
  })

  const api = apisauce.create({
    baseURL,
    headers: {
      'Cache-Control': 'no-cache',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    timeout: 10000,
  })

  const pathname = sourceURLObj.pathname || ''
  const response = yield* call(api.get, pathname, { ...sourceURLObj.query, query })

  if (response.ok) {
    return response.data
  } else {
    throw new Error('Problem getting search results', { cause: response.problem })
  }
}
